import React from "react"
import { UndoIcon } from "components/page-components/Icons/small"
import { updateInternalSearchSessionStorage } from "components/page-components/Internal-Search/utils"

export const ClearRefinements = ({ set_focussed, setSearchState }) => {
  const initial_search_state = {
    distinct: true,
    refinementList: {
      scope: ["website", "notice"],
      type: [
        "news",
        "page",
        "lexicon",
        "blog",
        "author",
        "notice",
        "help-article",
        "job_posting",
        "event",
      ],
      tags: [],
    },
    query: "",
  }
  const clear_all = () => {
    updateInternalSearchSessionStorage({
      focussed: false,
      last_search_state: initial_search_state,
    })
    setSearchState(initial_search_state)
    set_focussed(false)
  }

  return (
    <React.Fragment>
      <div className="level-item mr-1">
        <div
          className="is-clickable"
          onClick={clear_all}
          title="Filter zurücksetzen"
          onKeyPress={() => {}}
          role="button"
          tabIndex="-1"
          aria-label="clear all Refinements"
        >
          <span className="help mt-0 is-hidden-mobile">Zurücksetzen</span>
        </div>
      </div>
      <div className="level-item">
        <div
          className="is-clickable is-flex"
          onClick={clear_all}
          title="Filter zurücksetzen"
          onKeyPress={() => {}}
          role="button"
          tabIndex="-1"
          aria-label="clear all Refinements"
        >
          <UndoIcon {...{ color: "#FFFFFF", size: 0.7 }} />
        </div>
      </div>
    </React.Fragment>
  )
}
